import axios from 'axios'
import moment from 'moment'
import store from 'store2'

import Vue from 'vue'

/* eslint-disable camelcase */

const EventBus = new Vue()

let AuthService
let expiration
const axiosAuth = axios.create()
axiosAuth.interceptors.request.use(
  (config) => {
    const headers = AuthService.getAuthHeaders()
    return {
      ...config,
      headers: {
        ...config.headers,
        ...(headers ? { Authorization: headers } : {}),
      },
    }
  },
  (error) => {
    return Promise.reject(error)
  },
)

let firstTimeFlag = true
export default AuthService = {
  async signIn ({ email = '', password = '' }) {
    const credentials = { email, password }
    try {
      const { data } = await axiosAuth.post(`/ia/contexte_usager/sign_in.json`, { ia_contexte_usager: credentials })
      const { token } = data
      AuthService.token = token
      console.log('token', AuthService.token)

      return AuthService.checkAuth()
    } catch (e) {
      throw Error(e.message)
    }
  },
  async signOut () {
    try {
      await axiosAuth.delete(`/ia/contexte_usager/sign_out.json`)
      AuthService.token = null
      await AuthService.checkAuth()
    } finally {
      AuthService.emit('auth:disconnect')
    }
    return true
  },
  async checkAuth (force) {
    const token = AuthService.token
    const shouldCheckToken = AuthService.shouldCheckToken()
    force = firstTimeFlag || force
    const p$ = !shouldCheckToken && token && !force
      ? Promise.resolve({ token: AuthService.token })
      : AuthService._validateToken(token)
    return p$
      .then(
        ({ date_expiration: expirationDate, token }) => {
          expiration = expiration || expirationDate
          return token
        },
        (e) => {
          AuthService.token = null
          expiration = null
          throw Error(e)
        }
      )
  },
  async _validateToken (token) {
    firstTimeFlag = false
    try {
      if (!token) throw Error('Token invalide')
      const data = await axiosAuth.get(`/api/v2/ia/tokens.json`, { params: { token } }).then(({ data }) => data)
      const { date_expiration: expirationDate } = data
      if (!expirationDate) throw Error('Token expiré')
      AuthService.token = token
      AuthService.emit('auth:success', { ...data, token })
      return { ...data, token }
    } catch (e) {
      AuthService.emit('auth:fail', e)
      throw Error(e.message)
    }
  },

  get token () {
    return AuthService.getToken()
  },
  set token (token) {
    if (token) {
      AuthService.persistToken(token)
    } else {
      AuthService.deleteToken()
    }
  },
  shouldCheckToken () {
    const token = AuthService.token
    if (!token) return false
    if (!expiration) return true
    const nowMoment = moment()
    const expirationMoment = moment(expiration * 1000, 'x')
    return nowMoment.isAfter(expirationMoment)
  },
  persistToken (token) {
    return store.set('id_token', token)
  },
  deleteToken () {
    return store.remove('id_token')
  },
  getToken () {
    return store.get('id_token')
  },
  getAuthHeaders () {
    const token = AuthService.token
    return token ? `Bearer ${token}` : undefined
  },

  // Events
  on (...args) {
    EventBus.$on(...args)
  },
  off (...args) {
    EventBus.$off(...args)
  },
  emit (...args) {
    try {
      EventBus.$emit(...args)
    } catch (e) {
      console.warn(e)
      throw Error(e.message)
    }
  },
}



// WEBPACK FOOTER //
// ./src/services/auth.js